import axios from "axios";
import type { DomainErrorPayload } from "../types";

const baseURL = import.meta.env.VITE_API_URL || "/api";
export const http = axios.create({ baseURL, timeout: 20_000 });

http.interceptors.request.use((config) => {
    const token = localStorage.getItem("wms.token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

http.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("wms.token");
            localStorage.removeItem("wms.user");
            if (window.location.pathname !== "/login") window.location.href = "/login";
        }
        return Promise.reject(error);
    },
);

export const idempotencyHeaders = () => ({ "Idempotency-Key": crypto.randomUUID() });
export const getErrorMessage = (error: unknown, fallback = "Não foi possível concluir a operação.") => {
    if (axios.isAxiosError<DomainErrorPayload>(error)) return error.response?.data?.message || fallback;
    return fallback;
};

/// Mensagem completa: a message do erro + os números do detalhe quando houver
/// (ex.: falta de saldo → pedido/disponível/faltam). Útil para toasts.
export const getErrorDetail = (error: unknown, fallback = "Não foi possível concluir a operação.") => {
    if (!axios.isAxiosError<DomainErrorPayload>(error)) return fallback;
    const data = error.response?.data;
    const message = data?.message || fallback;
    const details = (data?.details ?? {}) as Record<string, unknown>;
    const num = (value: unknown) =>
        value == null || value === "" ? null : Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 3 });
    const parts: string[] = [];
    const requested = num(details.requested);
    const available = num(details.available);
    const missing = num(details.missing);
    if (requested != null) parts.push(`pedido ${requested}`);
    if (available != null) parts.push(`disponível ${available}`);
    if (missing != null) parts.push(`faltam ${missing}`);
    return parts.length ? `${message} — ${parts.join(", ")}` : message;
};
